module.exports = __webpack_public_path__ + "img/Thumbnail_06.a6d4b385.png";